export default function GetFirstSegment(string) {
    if (string.startsWith("/")) string = string.slice(1)
    const parts = string.split("/")
    return parts[0] || null
}